import { useState } from 'react';
import EmailStep from './steps/EmailStep';
import PasswordStep from './steps/PasswordStep';
import SignupSteps from './steps/SignupSteps';
import ForgotPasswordStep from './steps/ForgotPasswordStep';

// Ported from roammyway_funnel's AuthFlow.tsx -- same state machine (starts
// at "email", server decides password vs. signup). "forgot-password" is an
// extra step here since Romaya has nowhere else to route it. No "otp" step:
// phone-OTP login is currently disabled funnel-wide (PHONE_OTP_LOGIN_ENABLED
// = false), so there's nothing live to reproduce.
export default function AuthFlow() {
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');

  const handleRouted = (confirmedEmail, nextStep) => {
    setEmail(confirmedEmail);
    setStep(nextStep);
  };

  const goBackToEmail = () => setStep('email');

  return (
    <div>
      {step === 'email' && (
        <div className="animate-auth-surface">
          <EmailStep initialEmail={email} onRouted={handleRouted} />
        </div>
      )}
      {step === 'password' && (
        <div className="animate-auth-surface">
          <PasswordStep email={email} onBack={goBackToEmail} onForgotPassword={() => setStep('forgot-password')} />
        </div>
      )}
      {step === 'signup' && <SignupSteps email={email} onBack={goBackToEmail} />}
      {step === 'forgot-password' && (
        <div className="animate-auth-surface">
          <ForgotPasswordStep initialEmail={email} onBack={goBackToEmail} />
        </div>
      )}
    </div>
  );
}
